export const parseHomeMarketsContent = (page) => {
  if (!page?.sections?.length) {
    return null;
  }

  const section = page.sections.find((item) => item.key === 'markets');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};

  if (!fields.title || !fields.text) {
    return null;
  }

  const posts = [];

  for (let index = 1; index <= 20; index += 1) {
    const category = fields[`post-${index}-category`];
    if (!category) {
      break;
    }

    posts.push({
      category,
      title: fields[`post-${index}-title`] || '',
      description: fields[`post-${index}-description`] || '',
      to: fields[`post-${index}-url`] || '#',
    });
  }

  if (posts.length === 0) {
    return null;
  }

  return {
    title: fields.title,
    text: fields.text,
    cta: {
      text: fields.ctaText || '',
      url: fields.ctaUrl || '',
    },
    posts,
  };
};
